import { render, staticRenderFns } from "./VendorRfxCriteriaList.vue?vue&type=template&id=8f80513e"
import script from "./VendorRfxCriteriaList.vue?vue&type=script&lang=js"
export * from "./VendorRfxCriteriaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports